import SocketIOContext from "./SocketIO.context";

import { useContext } from "react";

const useSocketIOContext = () => {
  return useContext(SocketIOContext);
};

export default useSocketIOContext;
